module.exports = __webpack_public_path__ + "img/red_009.70c6b6ec.png";